function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "night-clear");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "night-clear",
  transform: "translate(-1.000000, -1.000000)",
  fill: "#EFCC00",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M83.1330844,78.1130954 C65.8722923,76.670966 50.1976777,67.4796388 40.5151927,53.1226892 C30.8327078,38.7657395 28.1877172,20.7932085 33.3236972,4.25696585 C33.6302871,3.26351094 33.2853798,2.18429651 32.4593907,1.5525517 C31.6334015,0.92080689 30.5011825,0.870264487 29.6221517,1.42589699 C8.79508888,13.4179847 -2.2980966,37.157049 1.86749155,60.8199875 C6.03307971,84.4829261 24.5667596,103.010153 48.2379401,107.174291 C71.9091205,111.338428 95.6564533,100.249105 107.652718,79.4292941 C108.172784,78.5523053 108.103836,77.4466666 107.478842,76.6410339 C106.853848,75.8354012 105.799791,75.493459 104.820663,75.7787053 C97.8077536,77.9381877 90.4451178,78.7306811 83.1330844,78.1130954 Z",
  id: "Path"
})));

var SvgNightClear = function SvgNightClear(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "107px",
    height: "108px",
    viewBox: "0 0 107 108",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNightClear, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/night-clear.a99547e9.svg";
export { ForwardRef as ReactComponent };